import { Persistence, StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { produce } from 'immer';
import { IMemberSearchState } from 'src/app/pages/_searchs/member/member-search.model';

export class MemberListSaveFilterAction {
    static readonly type = `[MemberList] SaveFilter`;
    constructor(public payload: IMemberSearchState) { }
}

export class MemberListClearFilterAction {
    static readonly type = `[MemberList] ClearFilter`;
}

export class MemberListClearOnlyFiltersAction {
    static readonly type = `[MemberList] ClearOnlyFilters`;
}



export class MemberListStateModel {
    currentFilter: IMemberSearchState;
}

export class MemberListStoreModel {
    MemberListState: MemberListStateModel;
}

@Persistence()
@StateRepository()
@Injectable({
    providedIn: 'root'
})
@State<MemberListStateModel>({
    name: 'memberListState',
    defaults: {
        currentFilter: {
            tenants: [],
            criteria: null,
            columnFilters: []
        }
    } as MemberListStateModel
})
export class MemberListState extends NgxsDataRepository<MemberListStateModel> {

    @Selector()
    static currentFilter(state: MemberListStateModel) {
        return state.currentFilter;
    }

    constructor() {
        super();
    }

    @Action(MemberListSaveFilterAction)
    async saveFilter(ctx: StateContext<MemberListStateModel>, action: MemberListSaveFilterAction) {
        ctx.setState(produce(ctx.getState(), (draft: MemberListStateModel) => {
            draft.currentFilter = action.payload;
        }));

        return ctx.getState().currentFilter;
    }

    @Action(MemberListClearFilterAction)
    async clearFilter(ctx: StateContext<MemberListStateModel>, action: MemberListClearFilterAction) {
        ctx.setState(produce(ctx.getState(), (draft: MemberListStateModel) => {
            draft.currentFilter = {
                tenants: [],
                criteria: null,
                columnFilters: []
            } as IMemberSearchState;
            return draft;
        }));
    }

    @Action(MemberListClearOnlyFiltersAction)
    async clearOnlyFilters(ctx: StateContext<MemberListStateModel>, action: MemberListClearOnlyFiltersAction) {
        ctx.setState(produce(ctx.getState(), (draft: MemberListStateModel) => {
            draft.currentFilter.columnFilters = [];
            return draft;
        }));
    }

}

